import { escapeRegExp } from "./ep";

export const getMaxScore = (q,type) => {
	var score = 0;
	var max = 0;
	var advanced = false;
	var valuerange = {};

	if (type != undefined && type == 1) {
		for(var j in q.Answer) {
			valuerange[q.Answer[j].correct] = q.Answer[j].correct;
		}
		return valuerange;
	}

	//Add points of every answer
	if (q.Question.pointsxanswer) {
		for (var i in q.Answer) {
			if (q.Answer[i].config.type != 'closed_text') advanced = true;
			var val = q.Answer[i].correct == undefined ? 0 : parseInt(q.Answer[i].correct);
			score += Math.max(val,0);
			max = val > max ? val : max;
		}
	}
	else {
		score = 1;
	}

	if (!q.Question.multianswer && !advanced && max > 0) return max;

	return score;

}

	
export const getRealMaxScore = (q) => {
	var score = 0;
	var max = 0;
	var advanced = false;
	var valuerange = {};

	//Add points of every answer
	
	for (var i in q.Answer) {
		if (q.Answer[i].config.type != 'closed_text') advanced = true;
		var val = q.Answer[i].correct == undefined ? 0 : parseInt(q.Answer[i].correct);
		score += Math.max(val,0);
		max = val > max ? val : max;
	}

	if (!q.Question.multianswer && !advanced && max > 0) return max;

	return score;

}


export const getQuizMaxScore = (questions) => {
	var maxScore = 0;
	for (var i in questions) {
		maxScore += getMaxScore(questions[i]);
	}
	return maxScore;
}


/**
 * Validates a question to ensure that a user can continue
 * @param  {object} question the question
 * @param  {object} user     the user answers
 * @return {object} with the result and errors
 */
export const validateQuestion = (question,user) => {
	let res = {
		status:true,
		empty:[],
		notvalid:[]

	};

	for (var i in question.Answer) {
		let a = question.Answer[i];
		let hasNoAnswer = (user == undefined || user[question.Question.id] == undefined || user[question.Question.id][a.id] == undefined || user[question.Question.id][a.id] == "");

		//Rating
		if (a.config.type == "rating") {
			if (user == undefined) {
				res.status = false;
				res.empty.push(a.id);
				continue;
			}

			if (user[question.Question.id] == undefined) {
				res.status = false;
				res.empty.push(a.id);
			}
		}

		//List
		if (a.config.type == "list" && a.config.list_type=="list") {

			if (hasNoAnswer) {
				res.status = false;
				res.empty.push(a.id);
			}
			// else  {
			// 	let exists = false;
			// 	for (var j in a.config.values){
			// 		var reg = new RegExp("^"+user[question.Question.id][a.id]+"$",'gi');
			// 		if (reg.test(a.config.values[j])) {
			// 		//if (a.config.values[j] == user[question.Question.id][a.id]) {
			// 			exists = true;
			// 			break;
			// 		}
			// 	}

			// 	if (!exists) {
			// 		res.status = false;
			// 		res.notvalid.push(a.id);
			// 	}
			// }
		}


		//Autocomplete
		if (a.config.type == "list" && a.config.list_type=="autocomplete") {

			if (hasNoAnswer) {
				res.status = false;
				res.empty.push(a.id);
			}
			else  {
				let exists = false;
				for (var j in a.config.values){
					var reg = new RegExp("^"+user[question.Question.id][a.id]+"$",'gi');
					if (reg.test(a.config.values[j])) {
					//if (a.config.values[j] == user[question.Question.id][a.id]) {
						exists = true;
						break;
					}
				}

				if (!exists) {
					res.status = false;
					res.notvalid.push(a.id);
				}
			}
		}

		//Open text
		if (a.config.type == "open_text") {
			if (a.config.optional == undefined || a.config.optional == false ) {

				if (hasNoAnswer) {
					res.status = false;
					res.empty.push(a.id);
				}
			}

			//Validate
			if (!hasNoAnswer && a.config.validation == 'regexp') {
				var reg = new RegExp(a.config.regexp,'gi');
				if (!reg.test(user[question.Question.id][a.id])) {
					res.status = false;
					res.notvalid.push(a.id);
				}
			}
		}
	}

	return res;


}


/**
 * Givien the score of the quiz and the quiz results returns the right one
 * @param  {object or int} score   with the score in most or points
 * @param  {array} results containing the Results
 * @return {[type]}         [description]
 */
export const getQuizResult = (score,results) => {

	for (var i in results) {
		if (parseInt(results[i].QuizResult.min) > score) continue;
		if (parseInt(results[i].QuizResult.max) < score) continue;

		return results[i];
	}

	return false;

}


export const getQuizScore = (questions,user,type) => {
	var score = 0;
	var most = {};


	for (var i in questions) {
		let res = getQuestionScore(questions[i],user,undefined,type);

		if (type == 'majority') {
			for (var j in res) {
				if (most[j] == undefined) {
					most[j] = res[j];
				}
				else {
					most[j] += res[j];
				}
			}
		}
		else {
			score += res;
		}
	}

	if (type == "majority") return most;

	return score;

}


/**
 * Givien the most object with the votes of each option returns the most voted option and in cas of tie the lowest one
 * @param  {object} most [description]
 * @return {string}      the most voted option
 */
export const getMostAnswer = (most) => {

	let mostVotes = 0;
	let mostVoted;

	for (var i in most) {
		if (most[i] > mostVotes) {
			mostVotes = most[i];
			mostVoted = i;
		}
	}

	return mostVoted;
}

/**
 * Ensures that a quiz is valid, containing at least one question with answers
 * @param  {array} questions thes questions of teh quiz
 * @return {boolean}   true if the quiz is valid.
 */
export const validQuiz = (questions)=>{
	if(questions == undefined) questions = [];
	if (questions.length == 0) return false;

	return true;
	// for (var i in questions) {
		
	// }
}


export const answerScore = (a,u,q) => {

	var ua = u[a.question_id][a.id];
	var score = 0 ;
	var correct = parseInt(a?.correct ?? 0);

	//Let's find all the correct answers
	var rights = a.config.correct_values;
	if (rights != undefined && !Array.isArray(rights)) rights = rights.split("\n");

	if (q != undefined) {
		if (q.multiorder) {

			for (var i in rights) {
				if (rights[i] != ua) continue;
				return correct;
			}
			return 0;
		}
	}

	if (a.config.type == 'closed_text') return correct;

	//We score points equal to the rating
	if (a.config.type == 'rating' && a.config.scorepoints) return ua;


	//Check via regexp?
	if (a.config.correct_validation == 'regexp') {


		var reg = new RegExp(a.config.correct_regexp,'gi');

		//Set correct if it matches the answer
		if (reg.test(ua)) {
			return correct;
		}

	}

	for (var i in rights) {
		var reg = new RegExp("^"+escapeRegExp(rights[i])+"$",'gi');
		if (reg.test(ua)) {
			return correct;
		}
	}

	return 0;
}

export const getQuestionScore = (q,u,raw,score_type) => {
	var score = 0;
	var most = {};

	//score_type = "sum";
	//Let's dive into the answers
	for (var i in q.Answer) {
		
		//Let's find if the user has answered
		for (var k in u[q.Question.id]) {

			//Look for the answer
			if (k != q.Answer[i].id) continue;

			//If the question is sortable let's check if the order is the right one
			if (q.Question.multiorder) {

				var user_answer =  u[q.Question.id][k];
				var correct_values = q.Answer[i].config.correct_values;
				var points = parseInt(q.Answer[i].correct);

				for (var j in correct_values) {

					if (correct_values[j] != user_answer) continue;

					//In the right order
					score += points;
					break;
				}					

				//Go to the next one
				continue;
			}
			else {

				//Get the sore for the answer
				var ansc = answerScore(q.Answer[i],u);

				//Scorin majority?
				if (score_type == 'majority') {
					//var val = question.Answer[j].correct != undefined ? question.Answer[j].correct : '';
					var options = (""+ansc).split('');

					for (var r in options) {
						//if(options[r] == 0) continue;

						if(most[options[r]] == undefined) most[options[r]] = 0;

						most[options[r]]++;
					}
				}

				//Get the score of the answer
				score += ansc;
				
			}
		}
	}

	if (score_type == 'majority') {
		return most;
	}


	//If the question is pointsxanswer
	if(raw == undefined && (q.Question.pointsxanswer == false || q.Question.pointsxanswer == "0")) {
		let question_score = (q.Question.config.question_points != undefined && q.Question.config.question_points != "" ) ? parseInt(q.Question.config.question_points) : 1;
		
		let max_score = getRealMaxScore(q);
		
		return (score < max_score || max_score == 0) ? 0 : question_score;
	}

	return score;
}